import App from './App.jsx'
import ReactDOM from 'react-dom/client'
import './assets/css/main.css'

const root = ReactDOM.createRoot(document.querySelector('#root'))

root.render(<App />)
